import { useEffect, useMemo } from "react";
import { X } from "lucide-react";

/**
 * Renders live thumbnails of File[] before upload.
 * - files: File[] currently queued
 * - onRemove(index) optional: shows a small × to drop that file
 * - size: side length in px (default 88)
 */
export default function PhotoPreview({ files = [], onRemove, size = 88, testidPrefix = "photo-preview" }) {
  const urls = useMemo(() => files.map((f) => URL.createObjectURL(f)), [files]);
  useEffect(() => () => urls.forEach((u) => URL.revokeObjectURL(u)), [urls]);

  if (!files.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid={testidPrefix}>
      {files.map((f, i) => (
        <div key={i} className="relative group" data-testid={`${testidPrefix}-${i}`}>
          <img
            src={urls[i]}
            alt={f.name}
            className="object-cover border border-cmdBorder"
            style={{ width: size, height: size }}
          />
          <div
            className="text-[9px] text-zinc-500 mt-0.5 truncate font-mono-live"
            style={{ maxWidth: size }}
            title={f.name}
          >
            {f.name}
          </div>
          {onRemove && (
            <button
              type="button"
              onClick={() => onRemove(i)}
              className="absolute -top-2 -right-2 bg-black border border-cmdBorder text-white w-5 h-5 flex items-center justify-center hover:border-incidentRed hover:text-incidentRed"
              data-testid={`${testidPrefix}-remove-${i}`}
              title="Remove"
            >
              <X className="w-3 h-3" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
